{
  "title": "CI import",
  "actions": {
    "newImport": "New import",
    "cancelImport": "Cancel import",
    "cancelConfirm": "Cancel the import? CIs that are already written stay in the CMDB.",
    "downloadTemplate": "Download CSV template",
    "issuesReport": "Error report",
    "resultsExport": "Download result"
  },
  "form": {
    "importType": "Import type",
    "flat": "Flat list (CSV)",
    "graph": "Graph (JSON)",
    "ciType": "CI type",
    "ciTypeHint": "Not available for a graph: types come from the file nodes.",
    "templateHint": "The template has the ci_id column and the attribute columns of the selected CI type. For CIs that are parts of a composition, add the composed_of_ci_id column; to delete records, add the ci_deleted column.",
    "file": "File",
    "conflictPolicy": "On match with an existing CI",
    "streamHint": "The file is streamed, keep the dialog open until it is received.",
    "start": "Start import"
  },
  "error": {
    "fileExtension": "This import type requires a {{extension}} file.",
    "fileNotFlat": "The file starts as JSON: a flat list requires CSV.",
    "fileNotGraph": "The file does not start with a JSON object: a graph requires a graph file."
  },
  "policy": {
    "MERGE": "Merge with existing",
    "SKIP": "Skip row",
    "ERROR": "Treat as error"
  },
  "status": {
    "RECEIVING": "Receiving",
    "QUEUED": "Queued",
    "RUNNING": "Running",
    "DONE": "Done",
    "DONE_WITH_ERRORS": "Done with errors",
    "CANCELLED": "Cancelled",
    "REJECTED": "Rejected",
    "ABORTED": "Receiving aborted",
    "FAILED": "Failed"
  },
  "stage": {
    "RECEIVE": "Receiving",
    "VALIDATE": "Validation",
    "ORDER": "Ordering",
    "IDENTIFY": "Identification",
    "WRITE": "Writing",
    "FINISH": "Finishing"
  },
  "counters": {
    "rowTotal": "Rows in file",
    "created": "Created",
    "merged": "Merged",
    "unchanged": "Unchanged",
    "skipped": "Skipped",
    "links": "Links",
    "errors": "Errors",
    "deleted": "Deleted",
    "notFound": "Not found",
    "linkErrors": "Link errors"
  },
  "result": {
    "rows_one": "{{value}} row",
    "rows_other": "{{value}} rows",
    "created": "created {{value}}",
    "merged": "merged {{value}}",
    "skipped": "skipped {{value}}",
    "links": "links {{value}}",
    "errors": "errors {{value}}",
    "unchanged": "unchanged {{value}}",
    "deleted": "deleted {{value}}",
    "notFound": "not found {{value}}"
  },
  "jobs": {
    "graph": "Graph",
    "search": "Search by file name",
    "columns": {
      "file": "File",
      "status": "Status",
      "progress": "Progress",
      "createdAt": "Launched at"
    },
    "filters": {
      "active": "Active",
      "errors": "With errors",
      "mine": "Only mine"
    },
    "progress": "{{percent}} % · {{processed}} of {{total}}",
    "receiving": "Receiving the file",
    "queuedBehind": "Waiting for {{name}} to finish",
    "queued": "Waiting in the queue",
    "aborted": "The connection dropped while receiving, no CIs were created",
    "rejected": "Rejected on receiving",
    "failed": "Import aborted"
  },
  "details": {
    "format": "Format",
    "conflictPolicy": "On match",
    "author": "Started by",
    "startedAt": "Started",
    "elapsed": "Running for",
    "duration": "Duration",
    "progress": "{{processed}} of {{total}} rows",
    "rate": "{{rate}} CIs/s · about {{remaining}} left"
  },
  "issues": {
    "title": "Problem rows",
    "columns": {
      "line": "File line",
      "element": "Element",
      "level": "Status",
      "stage": "Stage",
      "ci": "CI in CMDB",
      "message": "Message",
      "record": "Record"
    },
    "level": {
      "ERROR": "Error",
      "CONFLICT": "Conflict"
    },
    "kind": {
      "NODE": "node {{number}}",
      "LINK": "link {{number}}"
    },
    "ciStatus": {
      "DELETED": "deleted",
      "NOT_FOUND": "not found",
      "FORBIDDEN": "no access"
    },
    "source": {
      "line": "Line {{number}} of the file",
      "NODE": "Node {{number}}",
      "LINK": "Link {{number}}",
      "extraValue": "extra value",
      "unparsed": "not parsed — as in the file",
      "truncated": "First 8 KB of the {{size}} record shown",
      "pretty": "Indented",
      "raw": "As in the file",
      "missing": "The record text is not saved: the job ran before the report started keeping it."
    }
  },
  "ciTypes": {
    "title": "By CI type",
    "noCIType": "Type not determined",
    "notInModel": "not in the model",
    "pending": "The breakdown appears when the job finishes",
    "pendingHint": "Record outcomes and their breakdown are taken once on completion — on any outcome, including cancellation and failure.",
    "columns": {
      "ciType": "CI type",
      "total": "Total"
    },
    "outcome": {
      "created": "Created",
      "merged": "Merged",
      "unchanged": "Unchanged",
      "skipped": "Skipped",
      "reference": "Reference",
      "deleted": "Deleted",
      "not_found": "Not found",
      "not_processed": "Not processed",
      "error": "Errors"
    }
  }
}
